import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const ProgrammesSection: React.FC = () => {
  const initiatives = [
    {
      title: 'Child Learning Support',
      desc: 'Providing underprivileged children’s with quality education and vital resources to unlock their full potential and build a brighter future.',
      icon: 'fas fa-graduation-cap',
      bgColor: '#f0f4ff',
      borderColor: '#4a90e2',
    },
    {
      title: 'Community Health Outreach',
      desc: 'Bringing essential medical care and health education to remote communities with limited healthcare access through compassionate outreach.',
      icon: 'fas fa-stethoscope',
      bgColor: '#fff0f5',
      borderColor: '#ff6f61',
    },
    {
      title: 'Women Skill Development',
      desc: 'Empowering women with transformative skills and mentorship for financial independence..',
      icon: 'fas fa-hands',
      bgColor: '#e6fff5',
      borderColor: '#1abc9c',
    },
    {
      title: 'Youth Career Building',
      desc: 'Empowering youth through career guidance and job opportunities for a successful future.',
      icon: 'fas fa-user-tie',
      bgColor: '#fff9e6',
      borderColor: '#f1c40f',
    },
    {
      title: 'Sustainable Community Growth',
      desc: 'Fostering sustainable community growth by providing resources to build self-reliant and thriving ecosystems.',
      icon: 'fas fa-leaf',
      bgColor: '#e6f0fa',
      borderColor: '#34495e',
    },
    {
      title: 'Emergency Relief Efforts',
      desc: 'Delivering urgent aid and rehabilitation support during natural disasters to foster recovery and rebuild communities.',
      icon: 'fas fa-ambulance',
      bgColor: '#ffe6e6',
      borderColor: '#c0392b',
    },
  ];

  return (
    <section className="initiatives-section py-5 bg-light">
      <Container>
        <h2 className="text-center mb-5 initiatives-heading">Our Key Initiatives</h2>
        <Row>
          {initiatives.map((initiative, index) => (
            <Col xs={12} sm={6} md={4} key={index} className="mb-4">
              <Card
                className="initiative-card shadow-sm h-100"
                style={{
                  backgroundColor: initiative.bgColor,
                  border: `2px solid ${initiative.borderColor}`,
                  borderRadius: '15px',
                }}
              >
                <Card.Body className="text-center p-4">
                  <i
                    className={`${initiative.icon} initiative-icon mb-3`}
                    style={{ color: initiative.borderColor, fontSize: '2.5rem' }}
                  ></i>
                  <Card.Title
                    className="initiative-title mb-3"
                    style={{ color: initiative.borderColor, fontSize: '1.5rem' }}
                  >
                    {initiative.title}
                  </Card.Title>
                  <Card.Text className="initiative-desc" style={{ color: '#555', fontSize: '1rem' }}>
                    {initiative.desc}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ProgrammesSection;